import React from 'react';
import { useTranslation } from 'react-i18next';
import Avatar from '../../../Units/Avatar';

const fb = num => num > 0 ? `+${num}` : num;

const Item = ({ data, avatar }) => {
  const { t } = useTranslation();
    return (
        <div className="clubDataItem playerTab">
            <div className="clubDataAvatar avatarContainer">
                {avatar ? <Avatar data={avatar} /> : false}
            </div>
            <div className="clubDataItemColumn">
                <span className="clubDataName">{data.nickname}</span>
                <span className="clubDataId">ID: {data.accountId}</span>
            </div>
            <div className="clubDataItemColumn">
                {data.poker  ? <span className="clubDataItemStat">{t('pokerWL')}</span> : false}
                {data.poker  ? <span className="clubDataItemStat">{t('pokerFee')}</span> : false}
                {data.casino ? <span className="clubDataItemStat">{t('casino')}</span> : false}
                {data.liveCasino ? <span className="clubDataItemStat">{t('liveCasino')}</span> : false}
                {data.betting ? <span className="clubDataItemStat">{t('sports')}</span> : false}
                {data.casinoTournament ? <span className="clubDataItemStat">{t('tournaments.casinoTournaments')}</span> : false}
                {/* <span className={`clubDataItemStat`}>Bettings: {data.bettings || 0}</span> */}
            </div>
            <div className="clubDataItemColumn">
                {data.poker  ? (<span className="clubDataItemGive">{fb(data.poker.wl)}</span>)  : false}
                {data.poker  ? (<span className="clubDataItemGive">{data.poker.fee}</span>) : false}
                {data.casino ? (<span className="clubDataItemGive">{fb(data.casino.wl)}</span>) : false}
                {data.liveCasino ? (<span className="clubDataItemGive">{fb(data.liveCasino.wl)}</span>) : false}
                {data.betting ? (<span className="clubDataItemGive">{fb(data.betting.wl)}</span>) : false}
                {data.casinoTournament ? (<span className="clubDataItemGive">{fb(data.casinoTournament.wl)}</span>) : false}
            </div>
        </div>
    );
};

export default Item;